<template>
        <div class="warp">

            <el-row :gutter="12" class="box" type="flex" style="justify-content:stretch">
      <el-col :span="4">
        <el-card shadow="never" :body-style="{ padding: '12px' }">
          <div slot="header" class="clearfix card_header super_header">
            标签列表
            <el-button type="primary" icon="el-icon-plus" plain size="mini" @click="onAddTag"></el-button>
          </div>
          <div class="tree" v-if="leftList && leftList.length !== 0">
            <div v-for="(item,idx) in leftList" class="tree_item right_flex" :key="idx" :class="{'active':filters.classifyId === item.id}" @click="onChange(item)">
                <div>{{ item.classifyName }}</div>
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more el-icon--right" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="{type: 'del', row: item}"
                    >删除</el-dropdown-item>
                    <el-dropdown-item
                      :command="{type: 'edit', row: item}"
                    >编辑</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
            </div>
          </div>
          <!-- <el-tree
            ref="tree"
            :data="leftList"
            node-key="id"
            default-expand-all
            highlight-current
            :props="defaultProps"
            :current-node-key="0"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
          >
            <div slot-scope="{ node, data }" class="custom-tree-node">
              <div class="right_flex">
                <div>{{ data.classifyName }}</div>
                <el-dropdown v-else trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more el-icon--right" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="{type: 'del', row: data}"
                    >删除</el-dropdown-item>
                    <el-dropdown-item
                      :command="{type: 'edit', row: data}"
                    >编辑</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-tree> -->
        </el-card>
      </el-col>
      <el-col :span="20">
        
          <div class="rightBox" v-if="!editType">
          <div class="retrieve" ref="condition">
                        <!-- <div class="left">
                            <div class="child">
                                <span class="name">{{tabText}}</span>
                            </div>
                        </div> -->
                        <div class="right" style="margin-top:0;">
                            <el-button type="primary" size="small" 
							@click="edit()">添加</el-button>
                        </div>
                    </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                :default-sort="{prop: 'date'}"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    type="index"
                    show-overflow-tooltip
                    width="80px"
                    label="排序"/>
                <el-table-column v-if="!current || (current && current.classifyName !== '小快轻准')"
                    prop="id"
                    show-overflow-tooltip
                    label="债权产品ID">
                </el-table-column>
                <el-table-column
                    prop="debtProductName"
                    show-overflow-tooltip
                    label="产品名称">
                </el-table-column>
                <template v-if="!current || (current && current.classifyName !== '小快轻准')">
                <el-table-column
                    prop="loanTypeValue"
                    show-overflow-tooltip
                    label="贷款类型">
                </el-table-column>
                <el-table-column
                    prop="bankName"
                    show-overflow-tooltip
                    label="银行名称">
                </el-table-column>
                </template>
                <template v-else>
                  <el-table-column
                    prop="loanTypeValue"
                    show-overflow-tooltip
                    label="平台类型">
                    <template slot-scope="{row}">小快轻准</template>
                </el-table-column>
                   <el-table-column
                    prop="bankName"
                    show-overflow-tooltip
                    label="服务商名称">
                </el-table-column>
                </template>
                <el-table-column
                    prop="statusValue"
                    show-overflow-tooltip
                    label="状态">
                    <template slot-scope="{row}">
                      <span :style="`color:${row.classifyStatus === 0?'#f56c6c':'#67c23a'}`">{{row.classifyStatus === 0?'已禁用':'已启用'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <!-- <el-button size="small" type="primary" class="super" plain
                                   v-if="authorities.indexOf('sys:permission:background:intermediary:service:list:button:view') != -1" @click="check(scope.row)">查看</el-button> -->
                        <!-- <el-button :class="{'noclick':scope.row.isEditable==1||scope.row.status==1}"  size="small" type="primary" class="super" plain
                                     @click="scope.row.isEditable==0&&scope.row.status!==1? edit(scope.row) : ''">编辑</el-button> -->
                        <el-button :class="{'noclick':scope.row.isEditable==1}" size="small" :type="scope.row.classifyStatus === 0?'success':'warning'" class="super" plain
                                     @click="scope.row.isEditable==0 ? soldOut(scope.row) :''" >{{scope.row.classifyStatus === 0?'启用':'禁用'}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <Paging
                :PageData="PageData"
                v-if="tableData.length>0"
                @nextpage="nextpage"
                @previouspage="previouspage"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
                ></Paging>
            </div>
          </div>
          <div class="rightBox" v-else>
                    <div class="forms" v-if="addType !== 2">
                            <div class="child">
                                <div class="name"></div>
                                <div class="content" style="color:#F56C6C">提示：添加后不可删除，只可禁用，请谨慎添加</div>
                            </div>
                            <div class="child">
                                <div class="name"><span>*</span>产品选择：</div>
                                <div class="content">
                                  <el-select v-model="sendInfo.id" placeholder="请选择" style="width:300px">
                                    <el-option v-for="(item,idx) in prodList" :key="idx" :label="item.debtProductName" :value="item.id"></el-option>
                                  </el-select>
                                </div>
                            </div>
                            <div class="error" v-if="errors['sendInfo.id']">错误提示：{{errors['sendInfo.id']}}</div>
                            <div class="child">
                                <div class="name"><span>*</span>状态：</div>
                                <div class="content">
                                <el-radio-group v-model="sendInfo.classifyStatus">
                                    <el-radio :label="1">启用</el-radio>
                                    <el-radio :label="0">禁用</el-radio>
                                  </el-radio-group>
                                </div>
                                
                            </div>
                            <div class="error" v-if="errors['sendInfo.status']">错误提示：{{errors['sendInfo.status']}}</div>
                            <div class="child">
                                <div class="name"></div>
                                <div class="content">
                                  <div class="doubleBtn">
                                      <el-button size="small" type="primary" @click="submit">确认</el-button>
                                      <el-button size="small" @click="cancel">取消</el-button>
                                  </div>
                                </div>
                            </div>
                            
                    </div>
                    <div class="forms" v-else>
                      
                            <div class="child">
                                <div class="name"><span>*</span>标签名称：</div>
                                <div class="content">
                                  <el-input v-model="tagForm.classifyName" placeholder="限制6个字" maxlength="6"></el-input> 
                                </div>
                            </div>
                            <div class="error" v-if="errors['tagForm.classifyName']">错误提示：{{errors['tagForm.classifyName']}}</div>
                            
                            <div class="child">
                                <div class="name"></div>
                                <div class="content">
                                  <div class="doubleBtn">
                                      <el-button size="small" type="primary" @click="submit">确认</el-button>
                                      <el-button size="small" @click="cancel">取消</el-button>
                                  </div>
                                </div>
                            </div>
                            
                    </div>
          </div>
      </el-col>
    </el-row>
            
        </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        Paging
    },
    data(){
        return{
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
			status:[],//上下架
            options: [{
                value: '2',
                label: '中介服务名称'
                }, {
                value: '3',
                label: '发布账号'
            }, {
                value: '4',
                label: '更新账号'
            }],//检索下拉
            tableData:[],//表格数据
            filters:{
              classifyId: void 0, // 分类标签id
            currentPage:1, 
            pageSize: 10
            },
			sendInfo:{
          classifyId: void 0, // 分类标签id
          id: void 0,  
          classifyStatus:  void 0
            },
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
			dataInfo:'',//详细信息
			statusList:[],
      editType: void 0, // 编辑新增类型
      leftList: [], // 标签列表
      row:{},
      defaultProps: { // 树配置选项
        children: 'children',
        label: 'classifyName'
      },
      addType:1,
      tagName: void 0,
      tagForm:{
        classifyName: void 0,
        id: void 0,
        sortNumber: void 0
      },
      prodList:[],
      loading: false,
      current: {
        id:'',
        classifyName:'',
        sortNumber:void 0
      }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
      'tagForm.classifyName':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    if(this.addType === 2) return false;
                    else return true
                }
            },
            message:'请输入标签名称'
        },
        'sendInfo.id':{
            test:function(val){
                if(val){
                    return true;
                }else{
                  if(this.addType === 2) return true
                  else  return false;
                }
            },
            message:'请选择产品'
        },
        'sendInfo.classifyStatus':{
            test:function(val){
                if(val){
                    return true;
                }else{
                  if(val === 0) return true
                  else{
                    if(this.addType === 2) return true
                    else  return false;
                  }
                }
            },
            message:'请选择状态'
        }
    },
	created() {
    this.getProdList()
    this.getParent()
		getDict('UA_LS').then(data=>{
		    this.status = data.UA_LS;
		})
		// this.$axiosz.get('/rpc/sysDict/parentId/1069409909080064').then(res=>{
		//     if(res.code==200){
		// 		this.statusList=res.data
		//     }else{
		//         this.$alert(res.msg)
		//     }
		// })
	},
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 60
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 60
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      getProdList(){
        const param  = {...this.fitlers}
        this.$delete(param,'currentPage')
        this.$delete(param,'pageSize')
        this.$axiosc.get('/backstage/debt/financing/all/list',{params:param}).then(res=>{
			    if(res.code==200){
			        this.prodList=res.data.content || [];
			    }else{
			        this.$alert(res.msg)
			    }
			})
      },
      onChange(row){
        this.current = {...row}
        
        this.filters.classifyId = row.id
        this.filters.currentPage = 1
        this.sendInfo.classifyId = row.id
        this.getList()
      },
      //获取左边父级列表
        getParent:function(){
            this.$axiosc.get('/backstage/productClassify/list').then((r)=>{
                if(r.code==200){
                    this.leftList=r.data;
                    this.filters.classifyId=r.data && r.data.length !== 0?r.data[0].id : void 0;
                    this.getList();
                }else{
                    this.$alert(r.msg);
                }
            })
        },
      //提交
        submit:function(){
            this.$vuerify.clear();
            // const isCheck = this.addType === 2?(this.tagForm.classifyName !== ''?true:false):this.$vuerify.check()
            if(this.$vuerify.check()){
               if(this.addType === 2)
               {
                 this.$axiosc.post('/backstage/productClassify/save',this.$qs.stringify(this.tagForm)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            });
                            this.cancel();
                            this.getParent();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
               }else{
                this.$axiosc.post('/backstage/debt/financing/pending/classify',this.$qs.stringify(this.sendInfo)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            });
                            this.cancel();
                            this.getList();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
               }
            }
        },
      /** @description 点击树节点 */
    handleNodeClick(node) {
      if (node.id === 0) this.filters.kfType = null
      else this.filters.kfType = node.id
      // this.handleSearchs()
    },
    /** @description 搜索库房分类 */
    filterNode(value, data) {
      if (!value) return true
      return data.typeName.indexOf(value) !== -1
    },
    /**
    * @description 标签下拉菜单事件
    * @param {type} 'del'：删除，'edit'：编辑，
    */
    async handleCommand({ type, row }) {
      switch (type) {
        case 'del':
          this.delClassfy(row)
          break
        case 'edit':
          this.row = row
          this.tagForm.id = row.id
          this.tagForm.classifyName = row.classifyName
          this.handleClassify({ type: 2, row })
          break
      }
    },
    onAddTag(){
      this.addType = 2
      this.editType = 1
    },
      /** @description 添加/编辑标签列表 */
    handleClassify({ type, row }) {
      this.editType = 1
      if(type === 2) this.addType = 2
      this.row = row
    },
    delClassfy(row){
      this.$confirm('是否删除？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axiosc.delete(`/backstage/productClassify/del/${row.id}`).then(res=>{
                  if(res.code==200){
                    this.getParent()
                  }else{
                      this.$alert(res.msg)
                  }
              })
            }).catch(() => {});
		},
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		getList(){
      this.loading = true
			this.$axiosc.get('/backstage/debt/financing/all/list',{params:this.filters}).then(res=>{
			    if(res.code==200){
            this.loading = false
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
			    }else{
			        this.$alert(res.msg)
              this.loading = false
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //查询
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startDate=lookData.time[0];
				this.sendInfo.endDate=lookData.time[1];
			}else {
                this.sendInfo.startDate=null;
                this.sendInfo.endDate=null;
            }
            this.sendInfo.id=null;
            this.sendInfo.userName=null;
            this.sendInfo.name=null;
            this.sendInfo.intermediaryName=null;
            switch(lookData.drop){
                case '1':
                  this.sendInfo.id=lookData.dropValue;
                break;
                case '2':
                  this.sendInfo.intermediaryName=lookData.dropValue;
                break;
                case '3':
                  this.sendInfo.userName=lookData.dropValue;
                break;
                case '4':
                  this.sendInfo.updateUserName=lookData.dropValue;
                break;
            }
			// 检索值
			this.getList()
		},
        //表格查看按钮
        check:function(row){
            this.$router.push({path:'/agentManagement/detail',query:{id:row.id,index:'/agentManagement'}})
        },
        //发布 编辑
        edit:function(row){
            // if(row){//编辑
            //     this.$router.push({path:'/agentManagement/edit',query:{id:row.id,index:'/agentManagement'}})
            // }else{//发布
            //     this.$router.push({path:'/agentManagement/add',query:{index:'/agentManagement'}})
            // }
            this.$vuerify.clear();
            this.editType = 1
            this.addType = 1
            
            if(row){ //编辑
            
                // this.dialogEdit=true;
                // this.dialogEditTitle='编辑选项';
                this.sendInfo.id=row.id;
                this.sendInfo.classifyId=row.classifyId;
                this.sendInfo.classifyStatus=row.classifyStatus;
            }else{ //添加
                // this.dialogEdit=true;
                // this.dialogEditTitle='添加选项';
                this.sendInfo.classifyId=this.filters.classifyId;
            }
        },
        //表格下架,上架按钮
        soldOut:function(row){
		    let btnValue=row.classifyStatus === 0?'启用':'禁用';
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                  const param = {
                    classifyStatus: row.classifyStatus===0?1:0, // 0=禁用，1=启用
                    id:row.id
                  }
                    this.$axiosc.post('/backstage/debt/financing/pending/start',this.$qs.stringify(param)).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: btnValue+'成功!'
                            });
                            this.getList();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }).catch(() => {
            });
        },
        // 下一頁
        nextpage(val) {
          this.filters.currentPage=val;
          this.getList();
        },
        // 上一頁
        previouspage(val) {
          this.filters.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.filters.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
          this.filters.currentPage = val;
          this.getList()
        },
        //取消
        cancel:function(){
            this.editType = void 0;

            this.sendInfo.classifyId= void 0;
            this.sendInfo.classifyStatus=void 0;
            this.sendInfo.id= void 0;//自身id
            this.tagForm.id = void 0;
            this.tagForm.classifyName = void 0;
            this.addType = void 0
        },
    },
    watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>
<style scoped="scoped" lang="scss" >
.main{
  height:calc(100% - 40px);
}
	.noclick{
		color: #DDDDDD;
		border: 1px solid #ddd;
    cursor:not-allowed;
    &:hover,&:active,&:focus{
      color:#DDDDDD;
      border: 1px solid #ddd;
    }
	}
.rightBox{
            flex: 1;
            width:calc(100% - 240px);
            
        }
        .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            padding-top:40px;
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
           
        }
.rightBox{
  width:100%;
  .forms{
     /deep/ .error{
              padding-left:95px;
            }
  }
}
.right_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .el-dropdown,.el-button{
    position: absolute;
    right: 15px;
    line-height: 22px;
  }
}
.super_header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-button{
    padding:5px;
  }
}
.tree{
  &_item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 36px;
    color:#595959;
    padding:0 20px;
    cursor: pointer;
  }
  .active{
    background: #F2FBFF;
    color:#1069DD;
  }
}
.box{
  .el-card{
    height:100%;
    /deep/ .el-card__body{
    height:calc(100% - 80px);
    overflow-x: hidden;
    overflow-y:auto;
  }
  }
  
}
</style>
